import useIsCompanyStore from "@Hooks/selector/useIsCompanyStore";
import useCompanyStyle from "@Hooks/selector/useCompanyStyle";

export default function useCompanyStoreStyleForComponent(companyStorePropertyKey: string, defaultValue?: any) {
    const isCompanyStore = useIsCompanyStore()
    const style = useCompanyStyle()

    return isCompanyStore ? style[companyStorePropertyKey] : defaultValue
}